import {Outlet} from 'react-router';
import {ErrorBoundary} from '@/shared/components/ui/ErrorBoundary.tsx';
import {AuthProvider} from '@/shared/contexts/AuthContext.tsx';
import {ToastContainer, ToastProvider} from '@/shared/contexts/ToastContext.tsx';
import {QueryProvider} from '@/shared/providers/QueryProvider.tsx';

/**
 * Root layout component that wraps the entire application with providers.
 * This is the top-level layout in the route hierarchy.
 */
export const RootLayout = () => {
    return (
        <ErrorBoundary>
            <QueryProvider>
                <ToastProvider>
                    <AuthProvider>
                        <Outlet />
                        <ToastContainer />
                    </AuthProvider>
                </ToastProvider>
            </QueryProvider>
        </ErrorBoundary>
    );
};
